import {Container, Grid} from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import React from "react";


export default function Footer() {
    return (
        <Box
            sx={{
                width: "100%",
                height: "auto",
                // backgroundColor: "secondary.main",
                paddingTop: "1rem",
                paddingBottom: "1rem",
            }}
        >
            <Container maxWidth="lg">
                <Grid container direction="column" alignItems="center">
                    <Grid item xs={12}>
                        <Typography color="black" variant="h5">
                            Data.Gov Data Lake Corpus -- For Internal Use Only
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography color="textSecondary" variant="subtitle1">
                            {`${new Date().getFullYear()} | Junjie Xing | CSE | UMICH`}
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
};